<template>
  <div class="card-comment">
    <CommentItem :value="value" @change="$emit('change', $event)" />
    <div class="children-list" v-if="hasChildren">
      <el-button
        v-if="!children.length"
        size="mini"
        :loading="loading"
        @click="handleFetchChildren"
        class="btn-fetch-child"
      >查看评论</el-button>
      <CommentItem
        class="item-child"
        v-for="(item, index) in children"
        :key="item.id"
        v-model="children[index]"
      />
      <bean-pagination
        v-if="children.length"
        v-loading="loading"
        v-bind="pagination"
        @submit="handleFetchChildren"
        small
        layout="prev, pager, next"
      />
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import CommentItem from './comment-item.vue';

@Component({
  components: {
    CommentItem
  }
})
export default class Commment extends Vue {
  @Prop({ type: Object, default: () => ({}) }) value;

  pagination = {};
  children = [];
  loading = false;

  get hasChildren() {
    return _.get(this.value, 'commentable_comment_datum.comments_count') > 0;
  }

  async handleFetchChildren({ page = 1, size = 10 } = {}) {
    this.loading = true;
    try {
      const params = { per_page: size, root_id_eq: this.value.id, page };
      const { data, pagination } = await this.$request.get('/normal_comments', { params });
      this.children = data;
      this.pagination = pagination;
    } finally {
      this.loading = false;
    }
  }

}
</script>

<style lang="scss" scoped>
  .card-comment {
    margin-bottom: 20px;
    border: 1px solid $border-light;
    padding: 15px;
    background: #fff;
  }

  .children-list {
    background: rgb(249,250,251);
    padding: 0 20px;
    margin-top: 20px;

    .btn-fetch-child {
      margin: 15px 0;
    }

    .item-child {
      border-bottom: 1px solid $border-light;
      padding: 15px 0;
    }

    .el-pagination {
      padding: 15px 0;
    }
  }

</style>
